import { render, staticRenderFns } from "./DocumentCreationModal.vue?vue&type=template&id=1659d9ba&"
import script from "./DocumentCreationModal.vue?vue&type=script&lang=js&"
export * from "./DocumentCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports